// extracted by mini-css-extract-plugin
export default {"search":"d51063200bdf"};